import React from 'react';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  useDisclosure,
  useToast,
  Flex,
} from '@chakra-ui/react';
import moment from 'moment';

export default function PopModal(props) {
  const accountDetails = props.accountDetails;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);

  return (
    <>
      <Button onClick={onOpen}>{props.Icon}</Button>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Flex gap={2}>
              {props.head}
              {accountDetails.default && (
                <Text
                  fontWeight='normal'
                  color='green'
                  fontSize='md'>
                  (Default Account)
                </Text>
              )}
            </Flex>
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody pb={6}>
            <Flex
              direction='column'
              gap={2}
              p={6}
              width='100%'>
              <Flex gap={2}>
                <Text>Holder Name:</Text>
                <Text color='gray.500'>{accountDetails.holder_name}</Text>
              </Flex>
              <Flex gap={2}>
                <Text>Account Number:</Text>
                <Text color='gray.500'>{accountDetails.account_number}</Text>
              </Flex>
              <Flex gap={2}>
                <Text>Bank:</Text>
                <Text color='gray.500'>{accountDetails.bank_name}</Text>
              </Flex>
              <Flex gap={2}>
                <Text>Branch:</Text>
                <Text color='gray.500'>{accountDetails.bank_branch}</Text>
              </Flex>
              <Flex gap={2}>
                <Text>IFSC Code:</Text>
                <Text color='gray.500'>{accountDetails.ifsc}</Text>
              </Flex>
              <Flex gap={2}>
                <Text>Created on:</Text>
                <Text color='gray.500'>
                  {moment(accountDetails.created_at).format('DD MMM YY, HH:mm')}
                </Text>
              </Flex>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
